<template>
    <div>
        <custom-tooltip v-model="tooltipOpen" border>
            <app-button color="brand-blue" @click="openModal">···</app-button>
            <template #tooltip>{{ label }}</template>
        </custom-tooltip>
        <app-dialog v-model="isOpen" size="sm">
            <template #header>
                <h4 class="text-lg text-theme-base font-semibold">
                    {{ label }}
                </h4>
            </template>
            <div class="flex flex-col gap-3">
                <div v-for="group in groupedOptions" :key="group.key">
                    <p
                        v-if="group.title"
                        class="text-xs text-theme-muted uppercase mb-1"
                    >
                        {{ group.title }}
                    </p>
                    <div class="flex flex-col gap-2">
                        <div
                            v-for="option in group.options"
                            :key="option.key"
                            class="flex flex-col"
                        >
                            <app-button
                                :color="group.color"
                                @click="selectOption(option)"
                            >
                                {{ option.icon }} {{ option.label }}
                            </app-button>
                            <p
                                v-if="option.description"
                                class="text-xs text-theme-muted text-center mt-1 px-1"
                            >
                                {{ option.description }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "AdvancedOptionsButton",
    components: { AppDialog },
    props: {
        label: { type: String, default: "Opciones" },
        options: { type: Array, default: () => [] }
    },
    emits: ["option-click"],
    data: () => ({
        isOpen: false,
        tooltipOpen: false
    }),
    computed: {
        visibleOptions() {
            return this.options.filter((opt) => opt.show !== false);
        },
        hasGroups() {
            const groups = new Set(
                this.visibleOptions.map((o) => o.group).filter((g) => g != null)
            );
            return groups.size > 1;
        },
        modeOptions() {
            return this.visibleOptions.filter((o) => o.group === "mode");
        },
        actionOptions() {
            return this.visibleOptions.filter((o) => o.group === "action");
        },
        groupedOptions() {
            if (!this.hasGroups) {
                return [
                    { key: "all", title: "", options: this.visibleOptions }
                ];
            }
            return [
                {
                    key: "mode",
                    title: "Modos",
                    options: this.modeOptions,
                    color: "brand-yellow"
                },
                {
                    key: "action",
                    title: "Acciones",
                    options: this.actionOptions
                }
            ].filter((group) => group.options.length);
        }
    },
    methods: {
        openModal() {
            this.tooltipOpen = false;
            this.isOpen = true;
        },
        selectOption(option) {
            this.isOpen = false;
            this.$emit("option-click", option.key);
        }
    }
};
</script>
